import { TableFiltersProps } from "./types/tableFiltersProps";
import './tableFilters.scss';
import SelectInput from "../../selectInput/selectInput";
import { Option, SelectInputProps } from "../../selectInput/types/selectInputProps";
import { ReactComponent as FilterList } from "../../../../icons/filter_list.svg";
import { ReactComponent as SortByAlpha } from "../../../../icons/sort_by_alpha.svg";
import { ReactComponent as Close } from "../../../../icons/close.svg";
import { iconStyle } from "../../stylization";
import Input from "../../input/input";
import { inputProps, inputCustomizedProps } from "../../input/types/inputProps";
import ButtonField from "../../../buttonField/buttonField";
import { ButtonFieldProps } from "../../../buttonField/types/buttonFieldProps";
import { BtnProps, classNameBtn } from "../../button/types/buttonProps";
import UseDebounce from "../../../../helpers/debounce";
import { CSSProperties, useContext, useEffect, useState } from "react";
import { FiltersTable, SortConfig, SortType, TableContext } from "../../../../contexts/tableContext";
import { inputStateType } from "../../../../helpers/validation/validation";
import { ColumnType } from "../types/tableProps";
import DatepickerField from "../../../datepickerField/datepickerField";

const TableFilters = (props: TableFiltersProps) => {
    const { setFiltersTableDb, filtersTableDb, setFiltersTableTaskList, filtersTableTaskList, sortConfigDb, setSortConfigDb, sortConfigTaskList, setSortConfigTaskList } = useContext(TableContext);
    const [sortSelected, setSortSelected] = useState<SortType>(SortType.None);
    const [reload, setReload] = useState<boolean>(false);

    const getFilterType = (colName?: string) => {
        const col = props.columnConfig?.find(c => c.name === colName);
        return col !== undefined ? col.type : ColumnType.Text;
    }
    const filterType = getFilterType(props.openedByColumn);

    // Filters
    useEffect(() => {
        const hasSortSet = props.isDb ? sortConfigDb.filterColumnName === props.openedByColumn : sortConfigTaskList.filterColumnName === props.openedByColumn;
        const itemSortType = hasSortSet ? (props.isDb ? sortConfigDb.sortType : sortConfigTaskList.sortType) : SortType.None;
        setSortSelected(itemSortType);
        setReload(!reload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.openedByColumn])

    const setFilter = (e: any) => {
        _setFilter(e.target.value);
    }

    const _setFilter = (value: any) => {
        var filters: FiltersTable[] = props.isDb ? filtersTableDb.filter(item => item.filterColumnName !== '') : filtersTableTaskList.filter(item => item.filterColumnName !== '');
        var newFilter: FiltersTable = {};
        if (value != null && value !== undefined) {
            if (props.openedByColumn === "NUMER_IDENTYFIKACYJNY") {
                newFilter = {
                    filterColumnName: props.openedByColumn,
                    filterColumnValue: checkIfOnlyDigits(value) ? value : "",
                    filterType: filterType
                }
            } else {
                newFilter = {
                    filterColumnName: props.openedByColumn,
                    filterColumnValue: value,
                    filterType: filterType
                }
            }
        }

        if (filters.find(item => item.filterColumnName === props.openedByColumn)) {
            if (newFilter.filterColumnValue !== '' && newFilter.filterColumnValue !== undefined && newFilter.filterColumnValue !== null) {
                filters = filters.map(item => item.filterColumnName === props.openedByColumn ? newFilter : item);
            } else {
                filters = filters.filter(item => item.filterColumnName !== props.openedByColumn);
            }
        } else {
            filters.push(newFilter);
        }

        props.isDb ? setFiltersTableDb(filters) : setFiltersTableTaskList(filters);
    }

    const checkIfOnlyDigits = (value: string) => {
        return /^\d+$/.test(value);
    }

    const getFilterInputValue = () => {
        var existingFilter = props.isDb ? filtersTableDb.find(item => item.filterColumnName === props.openedByColumn) : filtersTableTaskList.find(item => item.filterColumnName === props.openedByColumn);
        return existingFilter ? existingFilter?.filterColumnValue : undefined;
    }

    // Clear filters button
    const clearFilters = () => {
        props.isDb ? setFiltersTableDb([]) : setFiltersTableTaskList([]);
        props.isDb ? setSortConfigDb({ sortType: SortType.None, filterColumnName: "" }) : setSortConfigTaskList({ sortType: SortType.None, filterColumnName: "" });
        setSortSelected(SortType.None);
        setReload(!reload);
    };

    const styleRight: CSSProperties = {
        display: 'flex',
        justifyContent: 'right',
    }

    var ClearbtnProps: BtnProps = {
        onClick: UseDebounce(clearFilters, 100),
        style: {
            width: 'auto',
            minWidth: '150px',
            paddingLeft: '20px',
            paddingRight: '20px',
            height: '49px'
        },
        className: classNameBtn.Small
    }

    const clearButtonFieldProps: ButtonFieldProps = {
        placeHolder: 'Wyczyść wszystkie filtry',
        BtnProps: ClearbtnProps,
        wrapperProps: {
            style: styleRight
        }
    }

    // Sort select
    const sortOptions: Option[] = [
        { name: 'malejąco', value: 1 },
        { name: 'rosnąco', value: 2 }
    ]

    const onSortChange = (opt: any) => {
        var sort: SortConfig = { sortType: opt.name, filterColumnName: props.openedByColumn }
        props.isDb ? setSortConfigDb(sort) : setSortConfigTaskList(sort);
    }

    const renderFilterType = () => {
        if (filterType === ColumnType.Date) {
            return <div className={inputStateType.searchWrapper}><DatepickerField
                className='body-txt-medium filterTable-date'
                selected={getFilterInputValue() as (Date | undefined)}
                inputPlaceholder="Wybierz datę"
                dateFormat='yyyy-MM-dd'
                fixedHeight={true}
                datepickerSharedProps={{ className: 'body-txt-medium' }}
                setValue={UseDebounce(_setFilter, 500)}
                hideLabel={true}
                keepPristine={true}
            /></div>;
        } else {
            const searchInputProps: inputProps = {
                placeholder: 'Wpisz frazę',
                style: {
                    width: '467px',
                    maxHeight: '54px'
                },
                className: 'body-txt-medium',
                value: getFilterInputValue() as (string | number | undefined),
                onChange: UseDebounce((e: any) => { setFilter(e) }, 500)
            }

            const customInputProps: inputCustomizedProps = {
                props: searchInputProps,
                className: inputStateType.searchWrapper,
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                },
                classNameIcon: inputStateType.iconValid
            }
            return <Input {...customInputProps} />;
        }
    }

    var selectProps: SelectInputProps = {
        options: sortOptions,
        additionalIcon: SortByAlpha,
        hideLabel: true,
        keepPristine: true,
        pristine: true,
        className: "leftFilterElement",
        selectedSingleOption: sortOptions.find(item => item.name === sortSelected),
        onChange: (e: any) => onSortChange(e),
        reload: reload
    }

    var extendedIconStyle: React.CSSProperties = { ...iconStyle, fill: "#453F3A" }

    return (
        <div className={`tableFilters ${(props.isOpened ? "canOverflow" : "")}`} style={{ height: props.isOpened ? '54px' : '0px' }}>
            <SelectInput {...selectProps} />
            <div className="centerFilterElement">
                <div><FilterList width={24} height={24} /><span>Filtruj</span></div>
                {renderFilterType()}
            </div>
            <div className="rightFilterElements">
                <ButtonField {...clearButtonFieldProps} />
                <div style={styleRight}><Close onClick={props.closeFilters} style={extendedIconStyle} /></div>
            </div>
        </div>
    );
}

export default TableFilters;